import { useMutation } from "react-query";
import axios from "axios";
import Config from "../Config";

export const useOrderStatus = (token) => {
    const processCashFreeOrderStatusTransaction = async (values) => {
        return await axios.post(`${Config.ApiUrl}/cashfree/orderstatus`, values, {
            headers: {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
    };

    const { mutate: orderStatusTransactionMutate, isLoading } = useMutation(
        processCashFreeOrderStatusTransaction
    );

    return {
        orderStatusTransactionMutate,
        isLoading,
    };
};